// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___e8ab9fdc250e0d6912e","cls2":"FeedbackModal-cls2___df9e0f5a29862bae49e FeedbackModal-cls1___e8ab9fdc250e0d6912e"};